import { useOpen } from '@twisto/hooks'

import { useFlow } from '../../flow/flow.context'

import { PromoCodeBox } from './promo-code-box'
import { PromoCodeEditModal } from './promo-code-edit-modal'

export const PromoCode = () => {
  const { isOpen, handleOpen, handleClose } = useOpen(false)

  const { flow, sessionId } = useFlow<'AdditionalInfoIntroStep'>()
  const { promoCode } = flow.currentStep

  return (
    <>
      <PromoCodeBox promoCode={promoCode.value} onClick={handleOpen} />
      <PromoCodeEditModal
        opened={isOpen}
        promoCode={promoCode.value}
        sessionId={sessionId}
        onClose={handleClose}
      />
    </>
  )
}
